import { logs } from '@shoppykey/tools';
import { history } from '@umijs/max';
import { Fetch, userService } from '@wanjia/panama-sdk';
import { HeaderTitle } from './components/header-title';
import { RightContent } from './components/right-content';
import { FetchClient } from './lib/fetch-client';
import { setCompanyId, setSysRoleId } from './lib/token';
import { GlobalData } from './schema/global-data';

const ignorePathList = ['/auth/login'];

export async function getInitialState(): Promise<GlobalData | undefined> {
  if (ignorePathList.includes(history.location.pathname)) {
    return undefined;
  }
  try {
    const currentUser = await userService.currentUser();
    setSysRoleId(currentUser.companyRoleId);
    setCompanyId(currentUser.companyId);
    return {
      ...currentUser,
    };
  } catch (error) {
    logs.error(error);
    return undefined;
  }
}

Fetch.client = FetchClient;
Fetch.basePath = '/api';
export const layout = () => {
  return {
    rightContentRender: () => <RightContent />,
    logo: '/logo.svg',
    menu: {
      locale: false,
    },
    fixSiderbar: true,
    layout: 'mix',
    splitMenus: true,
    contentWidth: 'Fluid',
    fixedHeader: false,
    token: {
      pageContainer: {
        marginInlinePageContainerContent: 24,
      },
      sider: {
        colorMenuBackground: '#fff',
        colorMenuItemDivider: '#dfdfdf',
        colorTextMenu: '#595959',
      },
    },
    headerTitleRender: (logo: any, title: string) => <HeaderTitle logo={logo} title={title} />,
  };
};
